export default {
    navigationBarTitleText: intl.get('commonPage.constructionDrawingTitle'),
  };
